import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const UserDetailsSection = ({ formData, showMoreBelowHint, orgInfo, editMode, toggleEditMode }) => {
    return (
        <div className="px-4 pt-3 pb-2">
            <div className="flex items-center justify-between gap-3">
                <div>
                    <div className="text-base font-semibold leading-5 text-[#02ADAD]">
                        Your Details
                    </div>
                    <div className="text-[11px] leading-4 text-[#02ADAD]">
                        These will be shown on the request
                        {showMoreBelowHint && (
                            <span> • More questions below ↓</span>
                        )}
                    </div>
                </div>
                {orgInfo.type === 'trust' && (
                    <div
                        onClick={toggleEditMode}
                        className="border flex items-center rounded h-[30px] border-[#02ADAD] cursor-pointer text-xs shrink-0"
                    >
                        <div className="text-[#02ADAD] h-full flex justify-center items-center font-medium px-2">
                            {!editMode ? 'Edit Details' : 'Cancel'}
                        </div>
                        <div className="bg-[#02ADAD] text-white h-full flex w-[30px] justify-center items-center">
                            <FontAwesomeIcon icon={!editMode ? faEdit : faTimes} />
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-sm">
                <div className="flex">
                    <div className="text-gray-600 mr-2">Name:</div>
                    <div className="font-semibold text-gray-900">
                        {formData?.staff_details?.contact_name}
                    </div>
                </div>

                <div className="flex">
                    <div className="text-gray-600 mr-2">Email:</div>
                    <div className="font-semibold text-gray-900">
                        {formData?.staff_details?.contact_email}
                    </div>
                </div>

                <div className="flex items-center">
                    <div className="text-gray-600 mr-2 whitespace-nowrap">School Name:</div>
                    {formData?.school_name}
                </div>

                <div className="flex items-center">
                    <div className="text-gray-600 mr-2 whitespace-nowrap">Postcode:</div>
                    {formData?.school_postcode}
                </div>
            </div>
        </div>
    )
}

export default UserDetailsSection